import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.query-builder.query-entry-section.util`, {
  'query-builder.count-menu.calculations.cumulative-sum': `Cumulative Sum`,
  'query-builder.count-menu.calculations.rolling-avg': `Rolling Average`,
  'query-builder.dg-group': `Group`,
  'query-builder.dg-group_other': `Groups`,
  'query-builder.dg-user': `User`,
  'query-builder.dg-user_other': `Users`,
  'query-builder.value-placeholder': `Select value…`,
  'reports.time-unit.x-units': `{{count}} {{timeUnit}}`,
});
